import { render, staticRenderFns } from "./Contactenos.vue?vue&type=template&id=40f749c0&"
import script from "./Contactenos.js?vue&type=script&lang=js&"
export * from "./Contactenos.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports